export const QUALIFICATION_TRUNCATION_LENGTH = 14;

export function truncateQualifications(
  qualifications: string[],
  truncationLength = QUALIFICATION_TRUNCATION_LENGTH
): string | undefined {
  const prefix = "For ";

  if (qualifications.length === 0) {
    return undefined;
  }

  const maxLengthWithoutPrefix = truncationLength - prefix.length;
  const allQualifications = qualifications.join(", ");

  // If all qualifications fit, return them all
  if (allQualifications.length <= maxLengthWithoutPrefix) {
    return `${prefix}${allQualifications}`;
  }

  // Try to fit as many qualifications as possible with +X suffix
  for (let index = qualifications.length - 1; index >= 1; index -= 1) {
    const remainingCount = qualifications.length - index;
    const plusSuffix = ` +${remainingCount}`;
    const partialQualifications = qualifications.slice(0, index).join(", ");

    if (partialQualifications.length + plusSuffix.length <= maxLengthWithoutPrefix) {
      return `${prefix}${partialQualifications}${plusSuffix}`;
    }
  }

  // If we can't fit multiple qualifications, try just the first one + suffix
  if (qualifications.length > 1) {
    const plusSuffix = ` +${qualifications.length - 1}`;
    if (qualifications[0].length + plusSuffix.length <= maxLengthWithoutPrefix) {
      return `${prefix}${qualifications[0]}${plusSuffix}`;
    }
  }

  // Last resort: show the full first qualification + count (don't truncate partial names)
  // Only show +X if there are actually other qualifications
  if (qualifications.length > 1) {
    const plusSuffix = ` +${qualifications.length - 1}`;
    return `${prefix}${qualifications[0]}${plusSuffix}`;
  }

  // Single qualification that doesn't fit - just show it without suffix
  return `${prefix}${qualifications[0]}`;
}
